import React from 'react'
import { useParams } from 'react-router-dom'
export default function DocumentDetailPage(){ const { type, id } = useParams(); return <div><h2>Document Detail</h2><p>Type: {type} — ID: {id}</p></div> }
